import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import MuiBreadcrumbs from 'components/common/MuiBreadcrumbs';
import {
  superAdminCustomer,
  superAdminCustomerAppointmentDetails,
} from 'routes/AppUrls';
import callIcon from 'assets/images/Dashboard/call.png';
import mailIcon from 'assets/images/Dashboard/mail.png';
import PhotoImage from 'assets/images/provider/image4.png';
import Provider from 'assets/images/sidebar/ProviderColor.png';
import rightArrow from 'assets/images/Dashboard/arrow-right.png';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerDetailsCallAPI } from 'store/SuperAdmin/getCustomerDetails/action';
import moment from 'moment';
import { ShimmerBox, ShimmerCircle } from 'components/common/Shimmer';

const CustomerDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const { state } = useLocation();

  const customerDetailApiData = useSelector(
    (state) => state?.getCustomerDetailsReducer?.data?.data
  );
  const customerDetailsLoading = useSelector(
    (state) => state?.getCustomerDetailsReducer?.loading
  );
  const [customerDetail, setCustomerDetail] = useState(
    customerDetailApiData ? customerDetailApiData : ''
  );

  const [breadcrumbsList, setBreadcrumbsList] = useState([
    {
      title: <FormattedMessage id="Customers" />,
      Link: superAdminCustomer(locale),
      isDisbale: false,
    },
    {
      title: <FormattedMessage id="Customer Details" />,
      Link: '',
      isDisbale: true,
    },
  ]);

  useEffect(() => {
    getCustomerDetailsApi();
  }, []);

  const getCustomerDetailsApi = () => {
    dispatch(
      getCustomerDetailsCallAPI(
        {
          id: state?.customerId ? state?.customerId : customerDetailApiData?.id,
        },
        {
          run: true,
          handleFunction: (res) => handleSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleSuccess = (res) => {
    setCustomerDetail(res?.data?.data);
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="14" list={breadcrumbsList} />
        {customerDetailsLoading ? (
          <Row className="bc-FFFFFF m-0 p-16 mt-3">
            <Col xs={12} md={6} className="mt-4">
              <div className="gap-3 flex">
                <ShimmerCircle size="88px" />
                <div className="flex-col d-flex justify-between">
                  <div>
                    <ShimmerBox width="200px" height="18px" className="mb-2" />
                  </div>
                  <div>
                    <ShimmerBox width="120px" height="14px" className="mb-2" />
                  </div>
                  <div className="flex gap-5">
                    <ShimmerBox width="150px" height="16px" />
                    <ShimmerBox width="200px" height="16px" />
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} className="mt-4">
              <div className="flex-col d-flex justify-between h-full">
                <Row>
                  <Col xs={12} md={6}>
                    <ShimmerBox width="150px" height="16px" className="mb-2" />
                  </Col>
                  <Col xs={12} md={6}>
                    <ShimmerBox width="150px" height="16px" className="mb-2" />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6}>
                    <ShimmerBox width="150px" height="16px" className="mb-2" />
                  </Col>
                  <Col xs={12} md={6}>
                    <ShimmerBox width="150px" height="16px" className="mb-2" />
                  </Col>
                </Row>
                <ShimmerBox width="300px" height="16px" />
              </div>
            </Col>
          </Row>
        ) : (
          <Row className="bc-FFFFFF m-0 p-16 mt-3">
            <Col
              xs={12}
              md={customerDetail?.role !== 'guest-app-user' ? 6 : 4}
              className="mt-4"
            >
              <div className="gap-3 flex">
                {customerDetail?.role !== 'guest-app-user' && (
                  <img
                    src={
                      customerDetail?.profile_image !== null &&
                      customerDetail?.profile_image !== undefined
                        ? customerDetail?.profile_image
                        : PhotoImage
                    }
                    alt={'icon'}
                    style={{
                      height: '88px',
                      width: '88px',
                      borderRadius: '50%',
                    }}
                  />
                )}
                <div className="flex-col d-flex justify-between">
                  <div>
                    <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                      {customerDetail?.name}
                    </p>
                  </div>
                  <div>
                    <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                      ID: {customerDetail?.id}
                    </p>
                  </div>
                  <div className="flex gap-5">
                    {customerDetail?.role !== 'guest-app-user' && (
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={callIcon}
                          alt="icon"
                          style={{ height: '20px', width: '20px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                          {customerDetail?.contact_number}
                        </p>
                      </Stack>
                    )}
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <img
                        src={mailIcon}
                        alt="icon"
                        style={{ height: '20px', width: '20px' }}
                      />
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                        {customerDetail?.email}
                      </p>
                    </Stack>
                  </div>
                </div>
              </div>
            </Col>

            <Col
              xs={12}
              md={customerDetail?.role !== 'guest-app-user' ? 6 : 8}
              className="mt-4"
            >
              <div className="flex-col d-flex justify-between h-full">
                <Row>
                  <Col xs={12} md={6}>
                    <div className="flex">
                      <p className="p-0 m-0 fs-16 fw-400 fc-9A9A9A ff-Akkurat_Bold">
                        <FormattedMessage id="User Type" /> {': '}
                        <span className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                          {customerDetail?.role}
                        </span>
                      </p>
                      {/* <p className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                        {customerDetail?.role}
                      </p> */}
                    </div>
                  </Col>

                  <Col xs={12} md={6}>
                    <div className="flex">
                      <p className="p-0 m-0 fs-16 fw-400 fc-9A9A9A ff-Akkurat_Bold">
                        <FormattedMessage id="Last Used" /> {': '}
                        <span className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                          {customerDetail?.last_used
                            ? moment(customerDetail?.last_used).format(
                                'DD MMM YYYY'
                              )
                            : ''}
                        </span>
                      </p>
                      {/* <p className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                        {customerDetail?.last_used
                          ? moment(customerDetail?.last_used).format(
                              'DD MMM YYYY'
                            )
                          : ''}
                      </p> */}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={6}>
                    <div className="flex">
                      <p className="p-0 m-0 fs-16 fw-400 fc-9A9A9A ff-Akkurat_Bold">
                        <FormattedMessage id="Frequency" /> {': '}
                        <span className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                          {customerDetail?.frequency}
                        </span>
                      </p>
                      {/* <p className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                        {customerDetail?.frequency}
                      </p> */}
                    </div>
                  </Col>

                  <Col xs={12} md={6}>
                    <div className="flex">
                      <p className="p-0 m-0 fs-16 fw-400 fc-9A9A9A ff-Akkurat_Bold">
                        <FormattedMessage id="Last Activity" /> {': '}
                        <span className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                          {customerDetail?.last_activity?.[0]?.last_activity}
                        </span>
                      </p>
                      {/* <p className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                        {customerDetail?.last_activity?.[0]?.last_activity}
                      </p> */}
                    </div>
                  </Col>
                </Row>

                <div className="flex gap-2">
                  <p className="p-0 m-0 fs-16 fw-400 fc-9A9A9A ff-Akkurat_Bold">
                    <FormattedMessage id="Location" /> {': '}
                    <span className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                      {customerDetail?.address}
                    </span>
                  </p>
                  {/* <p className="p-0 m-0 fs-16 fw-400 fc-292D32 ff-Akkurat">
                    {customerDetail?.address}
                  </p> */}
                </div>
              </div>
            </Col>
          </Row>
        )}

        {customerDetailsLoading ? (
          <>
            <h5 className="p-0 m-0 mt-4 fs-16 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Appointment History" />
            </h5>
            <Row className="mt-3 listHeader m-0 p-0 flex items-center">
              {[1, 2, 3, 4, 5].map((item) => (
                <Col key={item} lg={2} md={6} sm={12}>
                  <ShimmerBox width="100px" height="14px" />
                </Col>
              ))}
            </Row>
            <Row className="bc-FFFFFF m-0 p-0">
              {[1, 2, 3].map((item) => (
                <Row
                  key={item}
                  className="m-0 p-0 flex items-center listAppointment"
                >
                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="80px" height="12px" />
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <div className="flex items-center gap-2">
                      <ShimmerCircle size="24px" />
                      <ShimmerBox width="120px" height="14px" />
                    </div>
                    <ShimmerBox width="150px" height="12px" className="mt-1" />
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <ShimmerBox width="100px" height="12px" className="mb-1" />
                    <ShimmerBox width="80px" height="12px" />
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="80px" height="12px" />
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="100px" height="14px" />
                  </Col>
                </Row>
              ))}
            </Row>
          </>
        ) : (
          customerDetail?.appoinment_history?.length > 0 && (
            <>
              <h5 className="p-0 m-0 mt-4 fs-16 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Appointment History" />
              </h5>

              <Row className="mt-3 listHeader m-0 p-0 flex items-center">
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                    <FormattedMessage id="Booking ID" />
                  </p>
                </Col>
                <Col lg={3} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                    <FormattedMessage id="Service Location" />
                  </p>
                </Col>
                <Col lg={3} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                    <FormattedMessage id="Date & Time" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                    <FormattedMessage id="Price" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                    <FormattedMessage id="Actions" />
                  </p>
                </Col>
              </Row>

              <Row className="bc-FFFFFF m-0 p-0">
                {customerDetail?.appoinment_history?.length > 0 &&
                  customerDetail.appoinment_history.map((key, index) => (
                    <Row
                      key={index}
                      className="m-0 p-0 flex items-center listAppointment"
                    >
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                          {key?.booking_id}
                        </p>
                      </Col>

                      <Col lg={3} md={6} sm={12}>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center"
                        >
                          <img
                            src={Provider}
                            alt="icon"
                            style={{ height: '24px', width: '24px' }}
                          />
                          <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                            {key?.service_location}
                          </p>
                        </Stack>
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                          {key?.delivery_address}
                        </p>
                      </Col>

                      <Col lg={3} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                          {key?.slot_date !== null &&
                          key?.slot_date !== undefined
                            ? moment(key?.slot_date).format('DD MMM YYYY')
                            : ''}
                        </p>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                          {key?.slot_start_time !== null &&
                          key?.slot_start_time !== undefined
                            ? moment(key?.slot_start_time).format('hh:mm A')
                            : ''}
                        </p>
                      </Col>

                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat_Bold">
                          {key?.prize} {key?.currency}
                        </p>
                      </Col>

                      <Col lg={2} md={6} sm={12}>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center cursor-pointer"
                          onClick={() =>
                            navigate(
                              superAdminCustomerAppointmentDetails(locale),
                              {
                                state: { customerId: key?.appoinment_id },
                              }
                            )
                          }
                        >
                          <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                            <FormattedMessage id="View Details" />
                          </p>
                          <img
                            src={rightArrow}
                            alt="icon"
                            style={{ height: '20px', width: '20px' }}
                          />
                        </Stack>
                      </Col>
                    </Row>
                  ))}
              </Row>
            </>
          )
        )}
      </Col>
    </Row>
  );
};

export default CustomerDetails;
